import React from "react";
import { FormControlLabel, Switch, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { getConfigurationMode } from "./userConfiguration.mjs";
import { i18n } from "../../translate/i18n";

export const AI_OPERATIONAL_SKILL_NAMES = [
	"talk_handoff",
	"talk_query_context",
	"talk_add_internal_note",
	"talk_update_contact",
];

const useStyles = makeStyles(theme => ({
	root: {
		marginTop: theme.spacing(1.5),
		padding: theme.spacing(1.5),
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: 12,
	},
	title: { fontWeight: 700, marginBottom: theme.spacing(0.5) },
	help: { color: theme.palette.text.secondary, marginBottom: theme.spacing(1) },
	item: { display: "block", margin: 0 },
	itemHelp: {
		display: "block",
		color: theme.palette.text.secondary,
		margin: theme.spacing(-0.5, 0, 1, 6),
	},
}));

const resolveSelection = value =>
	Array.isArray(value) ? value : AI_OPERATIONAL_SKILL_NAMES;

const AiOperationalSkills = ({ values, setFieldValue }) => {
	const classes = useStyles();
	const selectedNames = resolveSelection(
		values.aiAgentProfile?.enabledInternalSkillNames
	);

	const toggleSkill = (skillName, enabled) => {
		const nextNames = enabled
			? Array.from(new Set([...selectedNames, skillName]))
			: selectedNames.filter(name => name !== skillName);

		setFieldValue("aiAgentProfile.enabledInternalSkillNames", nextNames);
		if (skillName === "talk_handoff") {
			setFieldValue(
				"aiAgentProfile.metadata.operationalHandoffEnabled",
				enabled
			);
		}
	};

	return (
		<div className={classes.root}>
			<Typography variant="subtitle2" className={classes.title}>
				{i18n.t("userModal.configuration.permissionsTitle")}
			</Typography>
			<Typography variant="body2" className={classes.help}>
				{i18n.t("userModal.configuration.permissionsHelp")}
			</Typography>
			{AI_OPERATIONAL_SKILL_NAMES.filter(skillName => skillName !== "talk_handoff" || getConfigurationMode(values.aiAgentProfile) !== "operational").map(skillName => (
				<div key={skillName}>
					<FormControlLabel
						className={classes.item}
						control={
							<Switch
								color="primary"
								checked={selectedNames.includes(skillName)}
								onChange={event =>
									toggleSkill(skillName, event.target.checked)
								}
							/>
						}
						label={i18n.t(
							`userModal.aiAgent.operationalSkills.items.${skillName}.label`
						)}
					/>
					<Typography variant="caption" className={classes.itemHelp}>
						{i18n.t(
							`userModal.aiAgent.operationalSkills.items.${skillName}.help`
						)}
					</Typography>
				</div>
			))}
		</div>
	);
};

export default AiOperationalSkills;
